<template>
  <div class="course-create-wrap">
    <a-form @submit="courseCreateOk" :form="form">
      <a-card :bordered="false" style="box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);">
        <div class="info-title">
          个人信息
        </div>
        <div class="info-content" style="padding-top:25px;">
          <a-row >
            <a-col :span="24" style="position:relative;">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="手机号   ">
                <a-input readonly value="15202020202"/>
                <a :span="2" style="position:absolute;right:-35px;">修改</a>
              </a-form-item>
              
            </a-col>
          </a-row>
          <a-row >
            <a-col :span="24" style="position:relative;">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="密码   ">
                <a-input readonly value="********"/>
                <a :span="2" style="position:absolute;right:-35px;">修改</a>
              </a-form-item>
              
            </a-col>
          </a-row>
          <a-row style="margin-bottom:30px;">
            <a-col :span="24" style="position:relative;">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="密码   ">
                <a-input readonly value="标准"/>
                <!-- <a :span="2" style="position:absolute;right:-35px;">修改</a> -->
              </a-form-item>
              
            </a-col>
          </a-row>
        </div>
      </a-card>
    </a-form>
  </div>
  
</template>

<script>

  import JEditor from '@/components/jeecg/JEditor'
  // import moment from 'moment'
  // import pick from 'lodash.pick'
  // import { FormTypes } from '@/utils/JEditableTableUtil'
  // import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
  function getBase64 (img, callback) {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result))
    reader.readAsDataURL(img)
  }
  export default {
    name: 'AccountDetail',
    components: { JEditor},
    mixins: [],
    data() {
      return {
        getTypeValue:"0",//获取方式
        kaikeValue:"0",//
        kaikeStatus:"0",
        form: this.$form.createForm(this),
        loading: false,
        imageUrl: '',
        previewVisible: false,
        previewImage: '',
        fileList: [{
          uid: '-1',
          name: 'xxx.png',
          status: 'done',
          url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
        }],
      }
    },
    methods: {
      handleCancel () {
        this.previewVisible = false
      },
      handlePreview (file) {
        this.previewImage = file.url || file.thumbUrl
        this.previewVisible = true
      },
      handleChange ({ fileList }) {
        this.fileList = fileList
      },
      teacherImgChange (info) {
        if (info.file.status === 'uploading') {
          this.loading = true
          return
        }
        if (info.file.status === 'done') {
          // Get this url from response in real world.
          getBase64(info.file.originFileObj, (imageUrl) => {
            this.imageUrl = imageUrl
            this.loading = false
          })
        }
      },
      teacherImgBeforeUpload (file) {

        const isJPG = /\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(file.name);

        if(!isJPG){
          this.$message.error('只能上传图片!')
        }
       
        const isLt5M = file.size / 1024 / 1024 < 5
        if (!isLt5M) {
          this.$message.error('图片大小要小于5MB!')
        }
        return isJPG && isLt5M
      },
      courseCreateOk(){
        alert("123");
      },
      
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
<style lang="scss" scoped >
  .course-create-wrap{
    .info-title{
      border-bottom: 1px solid #E7ECEF;
      line-height: 50px;
      height: 50px;
      padding-left: 25px;
    } 

    .info-content{
      .img-tip{
        color: #999999;
        font-size: 12px;
      }
      .ant-upload-list-picture-card{
        .ant-upload-list-item{
          width:142px!important;
          height:80px;
        }
      }
      .j-teacher-list{
        .j-teacher-item{
          border: 1px solid #D0DBE4;
          padding: 20px;
          .j-teacher-item-con{
            width: 587px;
            overflow: hidden;
            .j-teacher-item-upload{
              width: 90px;
              float: left;
              .ant-upload-select-picture-card{
                width: 80px;
                height:80px;
              }
            }
            .j-teacher-item-ctx{
              margin-left:90px;
            }
          }
          
        }
      }
      .kaike-tip{
        color:#FA6400;
        font-size: 12px;
        // line-height: 1;
      }
      .kaike-radio-list{
        line-height: 1;
        .kaike-radio-item{
          line-height: 1;
          margin-bottom: 12px;
          margin-top: 0px;
        }
      }
      
    }

    
  }
  

</style>